import { render, staticRenderFns } from "./img-cropper.vue?vue&type=template&id=3c746ab6&scoped=true&lang=pug&"
import script from "./img-cropper.vue?vue&type=script&lang=js&"
export * from "./img-cropper.vue?vue&type=script&lang=js&"
import style0 from "./img-cropper.vue?vue&type=style&index=0&id=3c746ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c746ab6",
  null
  
)

export default component.exports